<template>
  <div class="" v-if="this.screenIndicators == 0">
    <h1 class="clockText">{{ $t("nao-ha-dados") }}</h1>
    <img
      src="@/assets/Monitoramento.png"
      class="iconPermission"
      :alt="$t('nao-ha-dados')"
      :title="$t('nao-ha-dados')"
    />
  </div>
  <div v-else class="all">
    <div class="graph-area">
      <div class="indicators-header">{{ $t("unidades-produtivas") }}</div>
      <div class="graph">
        <apexcharts
          ref="gdiChart"
          v-if="numberOfProductionUnits == 1"
          :options="adherencesGraphProductionUnits"
          width="95%"
          height="200px"
          style="margin-top: 50px"
          :series="adherencesGraphProductionUnits.series"
        >
        </apexcharts>
        <apexcharts
          ref="gdiChart"
          v-if="numberOfProductionUnits == 2"
          :options="adherencesGraphProductionUnits"
          width="95%"
          height="370px"
          :series="adherencesGraphProductionUnits.series"
        >
        </apexcharts>
        <apexcharts
          ref="gdiChart"
          v-if="numberOfProductionUnits == 3"
          :options="adherencesGraphProductionUnits"
          width="95%"
          height="600px"
          :series="adherencesGraphProductionUnits.series"
        >
        </apexcharts>
        <apexcharts
          ref="gdiChart"
          v-if="numberOfProductionUnits == 4"
          :options="adherencesGraphProductionUnits"
          width="95%"
          height="1000px"
          :series="adherencesGraphProductionUnits.series"
        >
        </apexcharts>
        <apexcharts
          ref="gdiChart"
          v-if="numberOfProductionUnits == 5"
          :options="adherencesGraphProductionUnits"
          width="95%"
          height="1200px"
          :series="adherencesGraphProductionUnits.series"
        >
        </apexcharts>
        <apexcharts
          ref="gdiChart"
          v-if="numberOfProductionUnits == 6"
          :options="adherencesGraphProductionUnits"
          width="95%"
          height="1500px"
          :series="adherencesGraphProductionUnits.series"
        >
        </apexcharts>
      </div>
    </div>
    <div class="legend">
      <div class="aderence-legend-symbol"></div>
      <div class="aderence-legend">{{ $t("aderencia-1") }}</div>
      <div class="treated-occurrence-legend-symbol"></div>
      <div class="treated-occurrence-legend">{{ $t("ocor-tratadas-0") }}</div>
      <div class="minimal-aderence-legend-symbol"></div>
      <div class="minimal-aderence-legend">{{ $t("aderencia-minima") }}</div>
    </div>
  </div>
</template>

  
<script>
import VueApexCharts from "vue-apexcharts";
import MediatorGDI from "../utilites/MediatorGDI";

export default {
  components: {
    apexcharts: VueApexCharts,
  },

  data: function () {
    return {
      screenIndicators: "",
      numberOfProductionUnits: 1,
      units: [],
      adherencesGraphProductionUnits: {
        chart: {
          height: 600,
          width: 10 * 100,
          type: "bar",
          toolbar: {
            show: false,
          },
          events: {
            dataPointSelection: function (event, chartContext, config) {
              MediatorGDI.notify(
                config.w.globals.labels[config.dataPointIndex],
                "show-pgdi-info"
              );
            },
            dataPointMouseEnter: function (event) {
              event.fromElement.style.cursor = "pointer";
            },
          },
        },

        series: [],

        yaxis: {
          labels: {
            maxWidth: 600,
            style: {
              fontSize: "13px",
              fontWeight: 700,
            },
          },
        },

        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          },
          line: {
            horizontal: false,
          },
        },

        legend: {
          show: false,
          showForSingleSeries: true,
          customLegendItems: ["Aderência", "Ocor.Tratadas", "Aderência Mínima"],
          markers: {
            fillColors: ["#00A39F", "#FF7100", "#000"],
          },
        },

        tooltip: {
          marker: {
            show: false,
          },
        },

        colors: ["#00A39F", "#FF7100"],
      },
    };
  },

  methods: {
    loadChart(data) {
      this.switch(data.length);
      this.quantityIndicators = data.length;
      MediatorGDI.notify(this.quantityIndicators, "quantityIndicators");
      this.adherencesGraphProductionUnits.series = [
        {
          name: "Aderência (%)",
          type: "bar",
          data: data,
        },
      ];
    },

    switch(n) {
      if (n <= 5) this.numberOfProductionUnits = 1;
      else if (n < 11) this.numberOfProductionUnits = 2;
      else if (n < 21) this.numberOfProductionUnits = 3;
      else if (n < 31) this.numberOfProductionUnits = 4;
      else if (n < 41) this.numberOfProductionUnits = 5;
      else this.numberOfProductionUnits = 6;
    },
  },

  mounted() {
    MediatorGDI.notify(this, "init-graph-productionUnits");
  },
};
</script>
  
<style scoped>
.all {
  display: grid;
  grid-template-rows: 400px 0.2fr;
  margin-top: 80px;
}

.graph-area {
  display: grid;
  grid-template-columns: 1fr 6fr;
}

.indicators-header {
  display: flex;
  margin-right: 5px;
}

.graph {
  overflow-y: auto;
  overflow-x: hidden;
  margin-right: 200px;
}

.legend {
  display: flex;
  justify-content: space-evenly;
  font-size: 12px;
  width: 370px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
}

.aderence-legend {
  display: flex;
  justify-content: space-between;
}

.aderence-legend-symbol {
  background-color: #00a39f;
  border-radius: 2px;
  height: 15px;
  width: 15px;
}

.treated-occurrence-legend {
  display: flex;
  justify-content: space-between;
}

.treated-occurrence-legend-symbol {
  background-color: #ff7100;
  border-radius: 50%;
  height: 15px;
  width: 15px;
}

.minimal-aderence-legend-symbol {
  margin-top: 6px;
  background-color: #000;
  border-radius: 2px;
  height: 7px;
  width: 15px;
}

.indicators-header {
  margin-top: 150px;
  margin-left: 50px;
  font-size: 15px;
  font-weight: 500;
}

@media only screen and (max-height: 768px) {
  .all {
    margin-top: 0px;
    grid-template-rows: 330px 20px;
  }

  .graph-area {
    display: grid;
    grid-template-columns: 1fr 6fr;
  }

}

.iconPermission {
  position: absolute;
  width: 300px;
  top: Calc(50% - 158px);
  left: Calc(50% - 158px);
  opacity: 0.1;
}

.clockText {
  position: absolute;
  top: 50%;
  text-align: center;
  width: 99%;
  font-size: 1.5rem;
}
</style>